
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './resumencompra.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Presumencompra = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id692858a5c419e6f0648ca22d" >

      <div id="iiyb" className="">
      
      <div id="im6f" className="">
      
      <div id="is4uc" className="">
      
      <img
        className=""
        id="icmn6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhky00z2.png"
        alt="undefined"
      />
      
      <div className="" id="ihbt6">
        <>+504 8805-8638 / +504 8735-8194</>
      </div>
      
      <img
        className=""
        id="ilgyi"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhky21kx.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="iaoea"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhky2ofv.png"
        alt="undefined"
      />
      
      <div className="" id="i1fmo">
        <>promomas.tgu@gmail.com</>
      </div>
      
      </div>
      
      </div>
      
      <div id="io8p" className="">
      
      <div id="iz11r" className="">
      
      <img
        className=""
        id="iqh9l"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj76tl47.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ipi7" className="">
      
        <a
          target=""
          className=""
          id="i0rt5"
          href="/"
        >
          
    <div id="i5f7n" className="">
    <>Home</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i64qq"
          href="/catalogo"
        >
          
    <div id="i0v2r" className="">
    <>Catalogo</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iyoo9"
          href="/clientes"
        >
          
    <div id="i3bxm" className="">
    <>Clientes  y  Casos</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i366m"
          href="/contacto"
        >
          
    <div id="i3ztl" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      <div id="i2j0h" className="">
      
        <a
          target=""
          className=""
          id="iohmi"
          href="/carritocompras"
        >
          
    <div id="is0ki" className="">
    <>Carrito de Compra</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="izzx8y" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Home</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/catalogo"
        type=""
      >
        <>Catalogo</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/clientes"
        type=""
      >
        <>Clientes  y  Casos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      <div id="iwz9d6" className="">
      
      <img
        className=""
        id="igv25h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimj76tl47.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iaebgw" className="">
      
        <a
          target=""
          className=""
          id="ipy0ca"
          href="/carritocompras"
        >
          
    <div id="izfo4g" className="">
    <>Carrito de Compra</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      </div>
      
      <div id="i6pm" className="">
      
      <div id="iwt6w" className="">
      
      <div id="ifpmh" className="">
      
      <div className="" id="inb91">
        <>Eleve su marca con nuestros servicios de impresión digital</>
      </div>
      
      </div>
      
      <div id="i8rg5" className="">
      
      <div id="i763f" className="">
      
      <div id="imoyi" className="">
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="i4h92o"
        className=""
        data-aos="fade-right"
        data-aos-duration="10"
      >
      
      <div id="iycyi" className="">
      
      <div id="i1puyw" className="">
      
      <div className="" id="i4hjpl">
        <>Resumen de Compra</>
      </div>
      
      </div>
      
      <div id="ip9qn1" className="">
      
      <div id="iqc466" className="">
      
      <img
        className=""
        id="ix06ob"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhp1mq8x.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="in8866" className="">
      
      </div>
      
      <div id="i4nqkr" className="">
      
        <div id="iiuvbe" className="">
        
        <div className="" id="if9y0g">
          
      <div id="" className="">
      <>
         &#123;&#123; ciudad &#125;&#125;
        </>
      </div>
      
        </div>
        
        <div className="" id="ifdxf7">
          
      <div id="" className="">
      <>
         &#123;&#123; barrioocolonia &#125;&#125;
        </>
      </div>
      
        </div>
        
        <div className="" id="icx3mu">
          
      <div id="" className="">
      <>
         &#123;&#123; direccioncompleta &#125;&#125;
        </>
      </div>
      
        </div>
        <div className="" id="it3we5" />
        </div>
        
      </div>
      
      <div id="i9yie1" className="">
      
      <div id="iz2ny4" className="">
      
        <div id="icn3mg" className="">
        
      <div id="iz26k1" className="">
      
      <div className="" id="im2wgw">
        <>Productos</>
      </div>
      
      </div>
      <div className="" id="ibqyxt" />
      <div id="il428f" className="">
      
      <div className="" id="i0lkwu">
        <>Dirección de Envio</>
      </div>
      
      </div>
      
        <div className="" id="iwe006">
          
      <div id="iu7pqi" className="">
      <>
         &#123;&#123; nombre &#125;&#125;
        </>
      </div>
      
        </div>
        
        <div className="" id="ioky6u">
          
      <div id="in1yuh" className="">
      <>
         &#123;&#123; ciudad &#125;&#125;
        </>
      </div>
      
        </div>
        
        <div className="" id="i1um79">
          
      <div id="i1z18h" className="">
      <>
         &#123;&#123; barrioocolonia &#125;&#125;
        </>
      </div>
      
        </div>
        
        <div className="" id="i4pgze">
          
      <div id="irupkc" className="">
      <>
         &#123;&#123; direccioncompleta &#125;&#125;
        </>
      </div>
      
        </div>
        
      <div id="iwy2fo" className="">
      
      <div className="" id="i83xev">
        <>Total a Pagar</>
      </div>
      
      </div>
      
      <div id="ibm6qp" className="">
      
      </div>
      
      <div id="iljqii" className="">
      
        <a
          target=""
          className=""
          id="i7rfyi"
          href="/catalogo"
        >
          
    <div id="if3lnu" className="">
    <>Volver a Comprar</>
    </div>
    
        </a>
        
      </div>
      
        </div>
        
      </div>
      
      </div>
      
      <div id="ixwk4o" className="">
      
      <div id="iiww8m" className="">
      
      <div className="" id="ifv21g">
        <>Promomás</>
      </div>
      
      </div>
      
      <div id="iqia8d" className="">
      
      <img
        className=""
        id="idg28o"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl8hqoi.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iuttse" className="">
      
      <div id="i25xem" className="">
      
      <div className="" id="imteyo">
        <>Servicios</>
      </div>
      
        <a
          target=""
          className=""
          id="iy78h4"
          href="#"
        >
          
    <div id="izbti2" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i0xii1">
        <>Impresión Digital</>
      </span>
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ipqz1l"
          href="#"
        >
          
    <div id="inoqdq" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ilmxx8">
        <>Impresión Empresarial</>
      </span>
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ir56kh"
          href="#"
        >
          
    <div id="ias9g8" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ieztyk">
        <>Impresión Camisas</>
      </span>
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="itdtwi"
          href="#"
        >
          
    <div id="i6g3qf" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itz8r7">
        <>Impresión Vinil</>
      </span>
      
    </div>
    
        </a>
        
      </div>
      
      <div id="iuud1b" className="">
      
      <div className="" id="i7yb3u">
        <>Links</>
      </div>
      
        <a
          target=""
          className=""
          id="ikbm9q"
          href="#"
        >
          
    <div id="ind5fe" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="icv9sr">
        <>Términos de Uso</>
      </span>
      
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ia59al"
          href="#"
        >
          
    <div id="irnnqo" className="">
    
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="id6hyi">
        <>Política de privacidad</>
      </span>
      
    </div>
    
        </a>
        
      </div>
      
      <div id="i73f12" className="">
      
      <div className="" id="i2lbvh">
        <>Contacto</>
      </div>
      
      <div id="i466ik" className="">
      
      <img
        className=""
        id="i62w5l"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl9awu5.png"
        alt="undefined"
      />
      
      <div className="" id="iewlbx">
        <>+504 8805-8638 / +504 8735-8194</>
      </div>
      
      </div>
      
      <div id="idh5ss" className="">
      
      <img
        className=""
        id="izotfk"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl9gu29.png"
        alt="undefined"
      />
      
      <div className="" id="izb5r9">
        <>promomas.tgu@gmail.com</>
      </div>
      
      </div>
      
      <div id="iqhlmx" className="">
      
      <img
        className=""
        id="iqw36b"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl9gu29.png"
        alt="undefined"
      />
      
      <div className="" id="il620y">
        <>Res. El molinón, Tegucigalpa, Honduras</>
      </div>
      
      </div>
      
      </div>
      
      <div id="ip8fzp" className="">
      
      <div className="" id="ichv08">
        <>Ubicación</>
      </div>
      
      <div id="iqgohk" className="">
      
      <iframe
        title="Mapa"
        className=""
        id="io2gc7"
        frameBorder="0"
        src="https://maps.google.com/maps?&q=Res. El molinón, Tegucigalpa, Honduras&z=10&t=q&output=embed"
      />
      
      </div>
      
      </div>
      
      <div id="i5b5b3" className="">
      
      <div className="" id="iz6anw">
        <>Redes Sociales</>
      </div>
      
      <div id="ihi4ns" className="">
      
      <img
        className=""
        id="ijd5dp"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl9tcox.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="isber5" className="">
      
      <img
        className=""
        id="i69api"
        src="https://assetsprojects.s3.amazonaws.com/404pziimhl8hqoi.png"
        alt="undefined"
      />
      
      <div className="" id="iotx6g">
        <>Promomás©2025 Todos los Derechos reservados</>
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Presumencompra);
  